import { useEffect } from 'react';
import { getLanguages } from '../api';
import useAppState from '../state/useAppState';

export const useLanguages = (cellId) => {
    const { setLanguages } = useAppState();

    useEffect(() => {
        getLanguages(cellId).then((languages) => {
            setLanguages(languages);
        });
    }, [setLanguages, cellId]);
};
